import { BaseSettings } from 'Shared/frontend/themes/BaseSettings';
import { fluidType } from 'Shared/common/FluidType';
import { NunitoSans } from 'Shared/frontend/fonts/NunitoSans';
import { Inter } from 'Shared/frontend/fonts/Inter';
import { INav } from 'Common/config/INav';
import { PeopleCircle } from 'Shared/backend/icons/PeopleCircle';


export class OurWebsiteSettings extends BaseSettings
{

	fontIncludes()
	{
		return [
			NunitoSans,
			Inter,
		];
	}

	fonts()
	{
		return {
			text: '"Inter", sans-serif',
			heading:  '"Inter", sans-serif',
			subNav:  '"Inter", sans-serif',
			buttons: '"Inter", sans-serif',
			desktopNav:  '"Inter", sans-serif',
			mobileNav:  '"Inter", sans-serif',
		};
	}

	pages()
	{
		return [
			{
				key: 'home',
				frontend: {
					route: '/',
					metaTitle: 'Home'
				},
				backend: {
					route: '/home',
					title: 'Home'
				}
			},
			{
				key: 'showcase',
				frontend: {
					route: '/showcase',
					metaTitle: 'showcase'
				},
				backend: {
					route: '/showcase',
					title: 'Showcase'
				}
			},
			{
				key: 'events',
				frontend: {
					route: '/events',
					metaTitle: 'Events'
				},
				backend: {
					route: '/events-design',
					title: 'Events'
				}
			},
			
			{
				key: 'contact',
				frontend: {
					route: '/contact',
					metaTitle: 'Contact'
				},
				backend: {
					route: '/contact',
					title: 'Contact'
				}
			},

			{
				key: 'about',
				frontend: {
					route: '/about',
					metaTitle: 'about'
				},
				backend: {
					route: '/about',
					title: 'About'
				}
			},
		];
	}

	navContent(): INav
	{
		return {
			desktop: [
			//	{label:'Home',		link:'frontend/Home'},
			],
			mobile: {
				maxButtons: 0,
				includeMoreButton: false,
				links: [
					//{label:'Home',		link:'frontend/Home',		icon:Home},
				]
			}
		};
	}

	backendNavContent()
	{
		return [
			...super.backendNavContent(),
			{label:'Staff',		route:'/admin/staffResources',	icon:PeopleCircle},
		];
	}


	//todo Ben setup routes for the minor pages above see TownieSettings for a template to adapt?
	
}

